<template>
  <div class="app-container">
    <list ref="list" @change="onChange" @reload="reload">
      <template slot="toolbar-right" v-if="$permission.canWrite()">
          <el-button
            size="mini"
            type="primary"
            @click="create"
            icon="el-icon-plus"
            >添加</el-button
          >
          <!-- <el-button
            size="mini"
            class="filter-item"
            type="danger"
            @click="delRows"
            >删除</el-button
          > -->
      </template>
      <template slot="column" v-if="$permission.canWrite()">
        <el-table-column label="操作" fixed="right" align="center" width="150">
          <template slot-scope="{ row }">
            <el-button type="text" v-if="row.Status==2" @click.stop="detailsById(row.DocId)">查看</el-button>
            <el-button type="text" v-if="row.Status!=2" @click.stop="editById(row.DocId)">编辑</el-button>
            <el-button type="text" v-if="row.Status!=2" @click.stop="check(row)">审核</el-button>
            <el-button type="text" v-if="row.Status!=2" @click.stop="del(row)">删除</el-button>
          </template>
        </el-table-column>
      </template>
    </list>
       <div v-loading="isLoading">
      <template v-if="data.InvoiceTypeId!=null">
        <edit-list2 v-if="data.InvoiceTypeName=='收据'" ref="editList" is-detail />
        <edit-list1 v-else ref="editList" is-detail />
      </template>
      <div class="row-tb-head" style="margin-top: 10px;">
        <span>收款信息</span>
      </div>
      <el-table border class="tb-c-head" :data="data.RpIncomeDocReceiptDtos">
        <el-table-column prop="SettleName" label="结算方式" min-width="110" />
        <el-table-column prop="AccountName" label="收款账号" />
        <el-table-column prop="ReceiptAmount" label="收款金额" />
      </el-table>
    </div>
    <edit-dialog ref="editDialog" @close-saved="reload" />
    <details-dialog ref="detailsDialog" @close-saved="reload" />
  </div>
</template>
<script>
import curdMixins from "@/mixins/curd";
import list from "@/components/fund/contactcash/income/list";
import editList1 from "@/components/fund/contactcash/income/editList1";
import editList2 from "@/components/fund/contactcash/income/editList2";
import editDialog from "@/components/fund/contactcash/income/editDialog";
import detailsDialog from "@/components/fund/contactcash/income/detailsDialog";
export default {
  name: "receipt",
  mixins: [curdMixins],
  components: {
    list,
    editDialog,
    detailsDialog,
    editList1,
    editList2
  },
  data() {
    return {
      api: require("@/api/fund/contactcash/income").default,
      isLoading: false,
      data: {
        InvoiceTypeId: null,
        InvoiceTypeName: "",
        RpIncomeDocReceiptDtos: [],
      },
    }
  },
  methods: {
    reload() {
      this.$refs.list.reload();
      if (this.$refs.editList) this.$refs.editList.clear();
      this.data.InvoiceTypeId = null;
      this.data.InvoiceTypeName = "";
      this.data.RpCostDocPayDtos = [];
    },
    onChange(row) {
      
      this.data.RpIncomeDocReceiptDtos = [];
      this.isLoading = true;
      this.api.info(row.DocId).then((res) => {
        this.isLoading = false;
        if (res.Data) {
          this.data.InvoiceTypeId = res.Data.InvoiceTypeId;
          this.data.InvoiceTypeName = res.Data.InvoiceTypeName;
          this.$nextTick(() => {
            this.$refs.editList.setData(res.Data.RpIncomeDocDtsDtos);
          });
          this.data.RpIncomeDocReceiptDtos = res.Data.RpIncomeDocReceiptDtos;
        }
      });
    },
    detailsById(id){
        this.$refs.detailsDialog.openDetailsById(id);
    },
    check(row) {
      sessionStorage.setItem('check','1')
      this.$refs.detailsDialog.openEditById(row.DocId);
    },
    del(row) {
      this.$confirm("确认删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$refs.list.delRange(row.DocId);
        })
        .catch(() => {});
    },
    delRows() {
      let rows = this.$refs.list.getCheckedRows();
      if (rows.length == 0) {
        this.$message.warning("请选择要删除的数据");
        return;
      }
      this.$confirm("确认删除所选的数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let ids = rows.map((item) => {
            return item.DocId;
          });
          this.$refs.list.delRange(ids);
        })
        .catch(() => {});
    },
  },
};
</script>